/* eslint-disable */
/*
 * TODO:
 *
 * Maybe make basemodel and lexicons uneditable while building?
 *
 */

import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

import CRUDDropdown from './CRUDDropdown'

import {
  addCustomization,
  buildCustomization,
  deleteCustomization,
  getCustomizationLexicons,
  getCustomizations,
  getLexicons,
  renameCustomization,
  updateBasemodel,
  updateCustomizationLexicon
} from '../../modules/customization'

class Customization extends Component {

  componentDidMount() {
    this.props.getCustomizations()
  }

  /*
   * Functions that require a confirmation.
   */

  deleteCustomization = (customization_uuid) => {
    let name = this.props.customizations[customization_uuid].name
    confirmAlert(
      {title: 'Delete Customization ' + name,
       message: 'Are you sure you want to delete this customization? This will NOT delete associated data, nor any models already built from this customization.',
       confirmLabel: 'Delete Customization',
       cancelLabel: 'cancel',
       onConfirm: () => this.props.deleteCustomization(customization_uuid)
      }
    )
  }

  buildCustomization = (customization_uuid) => {
    let name = this.props.customizations[customization_uuid].name
    confirmAlert(
      {title: 'Build Model for Customization ' + name,
       message: 'This is computationally expensive, and may take up to 24 hours. You will receive an email when the model has been built or if an error occurs. Continue?',
       confirmLabel: 'Build Model',
       cancelLabel: 'cancel',
       onConfirm: () => this.props.buildCustomization(customization_uuid)
      }
    )
  }

  /*
   * Helper functions.
   */

  /*
   * Given an object indexed by some key, return a list of keys such that the
   * order of the keys corresponds to sorting the object by the given field.
   */

  sortedKeysByField = (obj, field) => {
    return Object.keys(obj).sort((k1,k2) => {
      let v1 = obj[k1][field]
      let v2 = obj[k2][field]
      if (v1 < v2) {
	return -1
      }
      if (v1 > v2) {
	return 1
      }
      if (k1 < k2) {
	return -1
      }
      if (k1 > k2) {
	return 1
      }
      return 0
    })
  }

  
  
  render() {
    let currentCustomization = undefined
    if (this.props.customizations && this.props.currentCustomization && this.props.customizations[this.props.currentCustomization]) {
      currentCustomization = this.props.customizations[this.props.currentCustomization]
    }
    
    return (
      <div>
	<div>
	  <label htmlFor="selectCustomizationDropdown">Customization: &nbsp;</label>
	  <CRUDDropdown id="selectCustomizationDropdown"
	  items={
	    this.sortedKeysByField(this.props.customizations, 'name').map((customization_uuid) => {
	      return { customization_uuid: customization_uuid,
		       name: this.props.customizations[customization_uuid].name }
	    })
	  }
	  trigger={currentCustomization?currentCustomization.name:undefined}
	  label="Customization"
	  onCreate={this.props.addCustomization}
	  onUpdate={(obj, newname) => {
	      this.props.renameCustomization(obj.customization_uuid, newname)
	  }}
  	  onRead={(obj) => {
	      this.props.getCustomizationLexicons(obj.customization_uuid)
	      this.props.getLexicons()
	  }}
	  onDelete={(obj) =>{this.deleteCustomization(obj.customization_uuid)}}
	  />
	</div>
	<div>
	  <p>Build status: {currentCustomization?currentCustomization.status:''}</p>
	  <p><label htmlFor="basemodelInput">Base Model: &nbsp;</label>
	    { this.props.currentCustomization && <input
								     type="text"
								     spellCheck="false"
								     pattern="[a-zA-Z0-9_.-]*"
								     size="30"
								     value={currentCustomization.basemodel?currentCustomization.basemodel:''}
								     onChange={evt => {
	    this.props.updateBasemodel(this.props.currentCustomization, evt.target.value, false)
	    }}
								     onBlur={evt => {
	    this.props.updateBasemodel(this.props.currentCustomization, evt.target.value, evt.target.checkValidity())
	    }}
	    />}
	  </p>
	</div>
	<div>
	  <p>
	    <button disabled={!currentCustomization || currentCustomization.status === 'Building'}
	      onClick={(e) => {
	      e.preventDefault()
	      this.buildCustomization(this.props.currentCustomization)
	      }}>
	      Build</button>
	  </p>
	</div>
	<div>
	  <p>Lexicons:</p>
	  <table>
	    <tbody>
	      {
	      this.sortedKeysByField(this.props.customizationLexicons, 'name').map(lexicon_uuid => {
	      return (
	      <tr key={lexicon_uuid}><td><input type="checkbox" disabled={currentCustomization?false:true} checked={this.props.customizationLexicons[lexicon_uuid].included} onChange={(e) => { this.props.updateCustomizationLexicon(this.props.currentCustomization, lexicon_uuid, e.target.checked)}} /></td><td>{this.props.customizationLexicons[lexicon_uuid].name}</td></tr>
	      )
	      })
	      }
	    </tbody>
	  </table>
	</div>
      </div>
    )
  } // end render()
} // end class Customization

/***********************************************************************
 *
 * Redux lifecycle stuff.
 *
 */

const mapStateToProps = state => ({
  customizations: state.customization.customizations,
  currentCustomization: state.customization.currentCustomization,
  customizationLexicons: state.customization.customizationLexicons
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addCustomization,
  buildCustomization,
  deleteCustomization,
  getCustomizationLexicons,
  getCustomizations,
  getLexicons,
  renameCustomization,
  updateBasemodel,
  updateCustomizationLexicon,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Customization)
